module.exports = __webpack_public_path__ + "media/images/ic_email-60b2e7be815239e39625678b282eff18.svg";